import { z } from 'zod';

import { CountryTaxTypeStaticOptions } from '@common/constants/sharedConstants';
import { Brand } from '@common/types/utils';

export const yesNoSchema = z.enum(['Y', 'N']);
export type YesNo = z.infer<typeof yesNoSchema>;

export const yesNoOptionalSchema = z.enum(['Y', 'N', '']).nullish().default(null);
export type YesNoOptional = z.infer<typeof yesNoOptionalSchema>;

export const periodNameSchema = z.string().regex(/(:?JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)-\d{2}/);
export type PeriodName = z.infer<typeof periodNameSchema>;

export const ssoSchema = z.string();
export type Sso = z.infer<typeof ssoSchema>;

export const withPeriodNameSchema = z.object({
  periodName: periodNameSchema,
}).strict();
export type WithPeriodName = z.infer<typeof withPeriodNameSchema>;

export const withSsoSchema = z.object({ sso: ssoSchema }).strict();
export type WithSso = z.infer<typeof withSsoSchema>;

export const withPeriodNameUnderscoreSchema = z.object({
  period_name: periodNameSchema, // eslint-disable-line camelcase
}).strict();
export type WithPeriodNameUnderscore = z.infer<typeof withPeriodNameUnderscoreSchema>;

export const withCompanyCodeSchema = z.object({
  companyCode: z.string(),
}).strict();
export type WithCompanyCode = z.infer<typeof withCompanyCodeSchema>;

export const withCountryTaxType = z.object({
  countryTaxType: z.string(),
}).strict();
export type WithCountryTaxType = z.infer<typeof withCountryTaxType>;

export const withCountryCodeSchema = z.object({
  countryCode: z.string(),
}).strict();
export type WithCountryCode = z.infer<typeof withCountryCodeSchema>;

export const withStaticOptions = z.object({
  staticOptions: z.nativeEnum(CountryTaxTypeStaticOptions),
}).strict();
export type WithStaticOptions = z.infer<typeof withStaticOptions>;

export const assignmentTypeSchema = z.enum(['USR', 'CC', 'BZ', 'CN', 'AL']);

export const assignmentOrPrivilegeSourceSchema = z.enum(['U', 'R', 'UR']);

export type HtmlString = Brand<string, 'html'>;

export type AdminImportAddUpdateParam = { addOrUpdate: 'Add' | 'Update' }

export const DropdownOptionDbSchema = z.object({
  LABEL: z.string(),
  VALUE: z.string().or(z.number()),
});

export type DropdownOptionDb = z.infer<typeof DropdownOptionDbSchema>;


export const DropdownOptionSchema = z.object({
  label: z.string(),
  value: z.string().or(z.number()),
});

export type DropdownOption = z.infer<typeof DropdownOptionSchema>;
